import {Observable} from 'rxjs';
import {TemplateRef} from '@angular/core';

export class Column {
  public name: string | Observable<string>;
  public prop: string;
  public sortable?: boolean;
  public formatter?: Function;
  public responsivePriority?: number;
  public cellTemplate?: TemplateRef<any>;
  public headerTemplate?: TemplateRef<any>;
  public type?: string = TextColumn.type;
  public width?: number;
  public minWidth?: number;
  public maxWidth?: number;
  public translate?: boolean = false;
  public resizeable?: boolean = false;
  public responsiveHideCallback?: Function;
  public paddingVal?: string;
  public hasStatus?: boolean = false;
  public noTruncate?: boolean = false;
  public filterable?: boolean;
  public filterProp?: string;
  public filterMultiSelect?: boolean = false;
  public isFilterTabOpen?: boolean = false;
  public isFilterSelected?: boolean = false;
  public filterItems?: any;
  public filterSelectedItems?: any;
  /** Stable automation hook rendered as data-testid on the cell. */
  public testId?: string;
}

export class BooleanColumn extends Column {
  static type = 'BooleanColumn';
  public placeholder?: string;
  public translateValue?: boolean;
  public valueFormatter?: Function;
  public valueClassFormatter?: Function;
  public showCallback?: Function;
  public change: Function;
  public possibleItems?: {
    key: boolean,
    value: string
  }[];
}

export class TextColumn extends Column {
  static type = 'TextColumn';
  public placeholder?: string;
  public translateValue?: boolean;
  public valueFormatter?: Function;
  public valueClassFormatter?: Function;
  public valueStatusFormatter?: Function;
  public showCallback?: Function;
  isHtml?: boolean;
  public possibleItems?: {
    key: string,
    value: string
  }[];
  public allowAdvance?: boolean;
  public allowAdvanceShowCallback?: Function;
  public advanceSearchKey?: string;
  public advancePossibilities?: {
    key: string,
    value: string
  }[];

  public valueTemplate?: any;
}

export class LinkColumn extends Column {
  static type = 'LinkColumn';
  public static LINK_EMAIL: string = 'EMAIL';
  public static LINK_TEL: string = 'TEL';
  public static LINK_LINK: string = 'LINK';
  public linkType: string;
}

export class NumberColumn extends Column {
  static type = 'NumberColumn';
  public valueFormatter?: Function;

}

export class DateColumn extends Column {
  static type = 'DateColumn';
  public format: string;
  public options;
}

export class ImageColumn extends Column {
  static type = 'ImageColumn';
  public imageWidth: number;
  public imageAlt?: string;
  public isSearch?: boolean = false;
  public imgSrcMap: Function;
}


export class ListColumn extends Column {
  static type = 'ListColumn';
  public listKey?: string;
  public isRemote?: boolean;
  public remoteService?: any;
  public remoteServiceFunction?: string;
  public listKeyTemplate?: any;

  constructor() {
    super();
    this.sortable = false;
  }
}

export class ActionColumn extends Column {
  static type = 'ActionColumn';
  public actionItems: ActionItem[];
}

export class ActionItem {
  public name?: string;
  public icon: string;
  public tooltip?: string;
  public translate?: boolean = false;
  public onclick: Function;
  public showCallback?: Function;
  public disabledCallback?: Function;
  public btnClass?: string = 'btn-primary';
  public status ? = true;
}
